import { CompositeType, IAudienceSearch, MultiRfmSearch } from 'types/api/audience';
import { ExternalListByClient } from 'types/api/external-list';

import { sharedABQueryKeyPrefixes } from './query-key-prefixes.util';

export const sharedABQueryKeys = {
  audience: (id: string) => [...sharedABQueryKeyPrefixes.ab(), 'audience', id] as const,
  categories: [...sharedABQueryKeyPrefixes.ab(), 'data-dictionary', 'sources'] as const,
  clientLists: (clients?: string) => [...sharedABQueryKeyPrefixes.ab(), 'client-lists', clients] as const,
  compositeData: (searchParameters: IAudienceSearch | MultiRfmSearch | undefined, compositeType: CompositeType) =>
    [...sharedABQueryKeyPrefixes.ab(), 'composite-data', searchParameters, compositeType] as const,
  dataPoints: (source?: string, category?: string) => {
    return [...sharedABQueryKeyPrefixes.ab(), 'data-dictionary', 'data-points', source, category] as const;
  },
  export: (searchParameters: IAudienceSearch | undefined) =>
    [...sharedABQueryKeyPrefixes.ab(), 'export', 'default', searchParameters] as const,
  externalLists: {
    all: [...sharedABQueryKeyPrefixes.ab(), 'external-lists'],
    byId: (secretKey?: string) => [...sharedABQueryKeys.externalLists.all, { secretKey }] as const,
    byParameters: (parameters: ExternalListByClient) =>
      [...sharedABQueryKeys.externalLists.all, { ...parameters }] as const,
  },
  flags: [...sharedABQueryKeyPrefixes.ab(), 'omit-flags'] as const,
  houseOrders: (clientIds?: string) => [...sharedABQueryKeyPrefixes.ab(), 'house-orders', clientIds] as const,
  mailCodes: (clientIds: string, packageCodes?: string) =>
    [...sharedABQueryKeyPrefixes.ab(), 'mail-codes', { clientIds, packageCodes }] as const,
  masterFiles: {
    ab: [...sharedABQueryKeyPrefixes.ab(), 'master-files-ab'] as const,
    eSun: [...sharedABQueryKeyPrefixes.ab(), 'master-files-e-sun'] as const,
  },
  omitLists: (clientIds?: string) => [...sharedABQueryKeyPrefixes.ab(), 'omit-lists', clientIds] as const,
  results: {
    all: [...sharedABQueryKeyPrefixes.ab(), 'audience-results'] as const,
    paged: (searchParameters: IAudienceSearch | MultiRfmSearch | undefined) =>
      [...sharedABQueryKeys.results.all, searchParameters] as const,
  },
  shop: {
    build: (shopId: string) => {
      const base = sharedABQueryKeys.shop.default(shopId);

      return [...base.slice(0, 1), 'build', ...base.slice(1)] as const;
    },
    default: (shopId: string) => [...sharedABQueryKeyPrefixes.ab(), 'shop', shopId] as const,
  },
  // shop: (shopId: string) => [...sharedABQueryKeyPrefixes.ab(), 'shop', shopId] as const,
  tags: {
    client: [...sharedABQueryKeyPrefixes.ab(), 'client-tags'] as const,
    mail: [...sharedABQueryKeyPrefixes.ab(), 'mail-tags'] as const,
    package: [...sharedABQueryKeyPrefixes.ab(), 'package-tags'] as const,
  },
  textValues: (source: string, name: string) => {
    return [...sharedABQueryKeyPrefixes.ab(), 'data-dictionary', 'data-points', source, name] as const;
  },
} as const;
